<template>
  <div class="container">
    <div class="search_box">
      <el-form ref="form" class="search_form" :model="tableParams" label-position="left">
        <el-form-item label="搜索内容" label-width="70px">
          <el-input v-model="tableParams.search" placeholder="请输入消息内容" clearable></el-input>
        </el-form-item>

        <el-form-item label="消息状态" label-width="70px">
          <el-select v-model="tableParams.isRead" clearable placeholder="请选择消息状态">
            <el-option v-for="item in messageTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="日期" label-width="70px">
          <el-date-picker v-model="YMD" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" class="search_area_btn" @click="onSubmit">搜索</el-button>
          <el-button icon="el-icon-upload2" class="search_area_btn" @click="downloadExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table_box">
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="message" label="消息内容">
          <template slot-scope="scope">
            <span>{{ scope.row.message }}</span>
            <span class="jump_cls" @click="jump(scope.row.orderStatusDesc)">{{ scope.row.orderStatusDesc }}</span>
            <span>点击可查看</span>
            <span class="jump_cls" @click="goDetail(scope.row)">工单详情</span>
          </template>
        </el-table-column>
        <el-table-column property="noticeType" label="通知类型"> </el-table-column>
        <el-table-column property="receiveUser" label="接收对象">
        </el-table-column>
        <el-table-column property="createUser" label="创建者">
        </el-table-column>
        <el-table-column property="createTime" label="日期">
        </el-table-column>
        <el-table-column property="readStatus" label="状态">
        </el-table-column>
      </el-table>

      <div class="paging_box">
        <!--  :current-page="currentPage4" -->
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 详情 -->
    <v-detail :show.sync="detailShow" :data="detailData"></v-detail>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util.js";
import detail from "./component/detail.vue";
import config from '@/utils/config';
export default {
  name: "",
  data () {
    return {
      tableData: [],
      tableParams: {},
      total: 0,
      detailShow: false,
      detailData: {},
      tableLoading: false,
      stateList: [],
      YMD: "",
      tableParams: {
        page: 1,
        limit: 10,
        search: "", // 搜索内容(联系人，联系人电话)
        isRead: null, // 1 已读/ 2 未读,
        startTime: "", // 开始时间
        endTime: "", // 结束时间
      },
      OrderNumData: {},
      messageTypeList: [{
        name: '已读',
        id: 1
      }, {
        name: '未读',
        id: 0
      }],
      orderStateList: [],
      userInfo: {}
    };
  },
  components: {
    "v-detail": detail
  },
  props: {},
  created () {
    this.getList();
    this.getOrderNum();
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  },
  methods: {
    getList () {
      this.tableLoading = true;
      this.$http.queryNotifyList(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.msg);
        }
      });
    },
    jump (name) {
      switch (name) {
        case "待审核":
          this.$router.push({ path: "/workOrder_Audit" });
          break;
        case "待审核被驳回":
          this.$router.push({ path: "/workOrder_Audit" });
          break;
        case "待指派（已审核）":
          this.$router.push({ path: "/workOrder_Audit?yishnehe" });
          break;
        case "我返还":
          this.$router.push({ path: "/workOrder_Audit?yishnehe" });
          break;
        case "维修中（派给我）":
          this.$router.push({ path: "/workOrder_Audit?yishnehe" });
          break;
        case "待确认被驳回":
          this.$router.push({ path: "/workOrder_Audit?daiqueren" });
          break;
        case "待确认":
          this.$router.push({ path: "/workOrder_Audit?daiqueren" });
          break;
        case "已完成":
          this.$router.push({ path: "/workOrder_Audit?yiwancheng" });
          break;
      }
    },
    goDetail (row) {
      this.detailShow = true;
      this.detailData = row;
    },
    timeChange (e) {
      if (e == null) {
        this.tableParams.startTime = "";
        this.tableParams.endTime = "";
      } else {
        this.tableParams.startTime = dateTransition(e[0]);
        this.tableParams.endTime = dateTransition(e[1]);
      }
    },
    getOrderNum () {
      this.$http.queryWorkOrderCount().then((res) => {
        if (res.code === 0) {
          this.OrderNumData = res.data;
        } else {
          this.OrderNumData = {};
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit () {
      if (this.YMD) {
        const ymd = dateTransition(this.YMD)
        this.tableParams.startTime = ymd + ' ' + '00:00:00'
        this.tableParams.endTime = ymd + ' ' + '23:59:59'
      } else {
        this.tableParams.startTime = ""
        this.tableParams.endTime = ""
      }
      this.getList();
    },
    downloadExport() {
      var data=this.tableParams;
      var url=config.baseUrl+'/workOrder/exportNotifyList?Authorization='+sessionStorage.getItem("Token");
      if(data.search){
        url+='&search='+data.search;
      }
      if(data.isRead){
        url+='&isRead='+data.isRead;
      }
      if(data.startTime){
        url+='&startTime='+data.startTime;
      }
      if(data.endTime){
        url+='&endTime='+data.endTime;
      }
      window.open(url, '_blank');
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";

.jump_cls {
  color: #0099CC;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/messagePage/messagePage.vue